import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { AnswerRecord } from '@/types/content'

export type DemoScreen =
  | 'start'
  | 'pretest-intro'
  | 'pretest'
  | 'level-result'
  | 'main-intro'
  | 'main'
  | 'analyzing'
  | 'report'

export type QuestionPhase = 'think' | 'answer'

export const useTestSessionStore = defineStore('testSession', () => {
  const screen = ref<DemoScreen>('start')
  const pretestIndex = ref(0)
  const mainIndex = ref(0)
  const phase = ref<QuestionPhase>('answer')
  const answers = ref<AnswerRecord[]>([])

  const isComplete = computed(() => screen.value === 'report')

  function startPretest(): void {
    screen.value = 'pretest-intro'
    pretestIndex.value = 0
    answers.value = []
  }

  function beginPretest(): void {
    screen.value = 'pretest'
    phase.value = 'answer'
  }

  function showLevel(): void {
    screen.value = 'level-result'
  }

  function showMainIntro(): void {
    screen.value = 'main-intro'
  }

  function beginMain(): void {
    screen.value = 'main'
    mainIndex.value = 0
    phase.value = 'think'
  }

  function showAnalyzing(): void {
    screen.value = 'analyzing'
  }

  function showReport(): void {
    screen.value = 'report'
  }

  function recordAnswer(answer: AnswerRecord): void {
    answers.value.push(answer)
  }

  function reset(): void {
    screen.value = 'start'
    pretestIndex.value = 0
    mainIndex.value = 0
    phase.value = 'answer'
    answers.value = []
  }

  return {
    screen,
    pretestIndex,
    mainIndex,
    phase,
    answers,
    isComplete,
    startPretest,
    beginPretest,
    showLevel,
    showMainIntro,
    beginMain,
    showAnalyzing,
    showReport,
    recordAnswer,
    reset,
  }
})
